import { render, staticRenderFns } from "./TextAreaField.vue?vue&type=template&id=be856bd2&"
import script from "./TextAreaField.vue?vue&type=script&lang=js&"
export * from "./TextAreaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be856bd2')) {
      api.createRecord('be856bd2', component.options)
    } else {
      api.reload('be856bd2', component.options)
    }
    module.hot.accept("./TextAreaField.vue?vue&type=template&id=be856bd2&", function () {
      api.rerender('be856bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/components/TextAreaField.vue"
export default component.exports